module.exports = __webpack_public_path__ + "img/therapy.45eb9f4f.png";